import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";

/* Fase C — presentación pública de Performance Relatives: cards premium
   agrupadas por línea materna/paterna, cerca del pedigree. Los nombres de
   caballos y niveles NUNCA se traducen; las relaciones y disciplinas sí. */
export const PerformanceRelatives = ({ relatives }) => {
  const { t } = useTranslation();
  const lines = ["maternal", "paternal"]
    .map((line) => ({ line, items: relatives.filter((r) => r.line === line) }))
    .filter((g) => g.items.length > 0);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="performance-relatives">
      {lines.map(({ line, items }) => (
        <div key={line} className="flex flex-col gap-3" data-testid={`pr-line-${line}`}>
          <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-[#0A0A0A]/40">
            {t(`pr.${line}Line`)}
          </span>
          <div className="flex flex-col gap-3">
            {items.map((r, i) => (
              <div
                key={i}
                className="bg-[#F9F9F9] rounded-2xl border border-black/5 p-5 lg:p-6 flex flex-col gap-1.5"
                data-testid={`pr-card-${line}-${i}`}
              >
                <span className="text-[10px] font-semibold uppercase tracking-[0.2em]" style={{ color: "var(--brand-accent, #1D4D3B)" }}>
                  {t(`pr.rel_${line}_${r.relationship || "other"}`)}
                </span>
                <div className="flex items-start justify-between gap-3">
                  <h3 className="text-lg font-medium tracking-tight text-[#0A0A0A]">{r.name}</h3>
                  {r.url && (
                    <a
                      href={r.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${r.name} — ${t("pub.officialRecords")}`}
                      data-testid={`pr-card-link-${line}-${i}`}
                      className="shrink-0 mt-1 text-[#0A0A0A]/30 hover:text-[#1D4D3B] transition-colors duration-200"
                    >
                      <ArrowUpRight className="w-4 h-4" aria-hidden="true" />
                    </a>
                  )}
                </div>
                {(r.discipline || r.level) && (
                  <p className="text-sm font-medium text-[#1D4D3B]">
                    {[r.discipline && t(`disc.${r.discipline}`), r.level].filter(Boolean).join(" · ")}
                  </p>
                )}
                {(r.sire || r.dam) && (
                  <p className="text-xs text-[#737373]">{[r.sire, r.dam].filter(Boolean).join(" × ")}</p>
                )}
                {r.result && <p className="text-sm text-[#0A0A0A]/70 leading-relaxed pt-0.5">{r.result}</p>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
